import { Formik } from "formik";
import PropTypes from "prop-types";
import React from "react";

const FormikContainer = ({
  initialValues,
  onSubmit,
  validate,
  formComponent: FormComponent,
  extraProps,
}) => (
  <Formik
    initialValues={initialValues}
    onSubmit={onSubmit}
    validate={validate}
    enableReinitialize={true}
  >
    {(formikProps) => <FormComponent {...formikProps} {...extraProps} />}
  </Formik>
);

FormikContainer.propTypes = {
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  validate: PropTypes.func,
  formComponent: PropTypes.elementType.isRequired,
  extraProps: PropTypes.object,
};

export default FormikContainer;
